export const bookmarkFragment = `
    isBookmarked
    canBookmark
`

export const lockFragment = `
    isLocked
    lockedAt
    lockedBy {
        guid
        name
        url
    }
    canLock
    canUnlock
`
